/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {deleteExportedFiles} from '../api'

export const useMutationDeleteExportedFiles = createReactQueryMutationHook('deleteExportedFiles', deleteExportedFiles)
